// extracted by mini-css-extract-plugin
module.exports = {"bandConfig_band_table":"styles_bandConfig_band_table__BylBD"};